module.exports = __webpack_public_path__ + "img/submit-hen.9f644341.png";